import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useState, useId } from 'react';
import { Title, Anchor, Collapsible } from '@mirohq-internal/website-ui-foundation';

/**
 * This is a responsive link list component that is an accordion
 * on mobile and a list on desktop.
 *
 * TODO: [WCDS] Extract for reuse later
 */ const ResponsiveLinkList = ({ label, items, showAllLink })=>{
    const [selected, setSelected] = useState('-1');
    return jsxs(React__default.Fragment, {
        children: [
            jsxs("div", {
                className: "d-none d-xl-flex flex-column gap-300 flex-shrink-1 flex-grow-1 text-tertiary",
                style: {
                    width: 0
                },
                children: [
                    jsx(Title, {
                        render: "h5",
                        as: "h3",
                        className: "mb-0",
                        children: label
                    }),
                    items?.map((item)=>jsx(Anchor, {
                            href: item.href,
                            children: jsx("div", {
                                className: "p",
                                children: item.label
                            })
                        }, `${JSON.stringify(item)}`)),
                    showAllLink && jsx(Anchor, {
                        href: showAllLink.href,
                        iconEnd: "ArrowRight",
                        className: "justify-content-start",
                        children: showAllLink.label
                    })
                ]
            }),
            jsx(Collapsible, {
                className: "d-flex flex-column d-xl-none px-300 border-bottom",
                selected: selected,
                setSelected: setSelected,
                eventKey: useId(),
                title: `${label}`,
                children: jsxs("div", {
                    className: "d-flex flex-column gap-300 pt-200 pb-600",
                    children: [
                        items?.map((item)=>jsx(Anchor, {
                                href: item.href,
                                className: "text-tertiary px-400",
                                children: item.label
                            }, `${JSON.stringify(item)}`)),
                        showAllLink && jsx(Anchor, {
                            href: showAllLink.href,
                            iconEnd: "ArrowRight",
                            className: "text-tertiary px-400 justify-content-start",
                            children: showAllLink.label
                        })
                    ]
                })
            })
        ]
    }, label);
};

export { ResponsiveLinkList };
